const module = { name: 'Fandango/geolocator', exports: {} }; const exports = module.exports;



import { Fandango_cookie as cookie } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



let _searchUrl = null


let _reverseUrl = null


const Errors = {
    BROWSER_UNSUPPORTED: 'Browser unsupported',
    GEOLOCATION_ERROR: 'Failed to get user location',
    GEOCODER: 'Geocoder Error',
    INVALID_LOCATION: 'Invalid location',
    MISSING_LOCATION_DETAILS: 'Failed to locate city or region',
    UNSUPPORTED_COUNTRY: 'Unsupported country',
}


const CookieNames = {
    AKAMAI_ZIP: 'akamai_set_zip',
    USER_COUNTRY: 'userCountry',
    USER_LOCATION: 'userlocation',
}


const GeolocateOpts = {
    timeout: 10000,
}
function getCookieDomain() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') {
        return 'localhost';
    }
    const domainMatch = hostname.match(/\.(fandango\.(com|co\.uk))$/);
    return domainMatch ? `.${domainMatch[1]}` : '.fandango.com';
}


const CookieOpts = {
    domain: getCookieDomain(),
    secure: true,
}
function serialize(obj) {
    const str = [];
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            str.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[prop]));
        }
    }
    return str.join('&');
}
function getUserLocation() {
    const raw = cookie.get(CookieNames.USER_LOCATION);
    if (!raw) {
        return {};
    }
    const result = {};
    raw.split('&').forEach((pair) => {
        const [key, val] = pair.split('=');
        if (key) {
            result[decodeURIComponent(key)] = decodeURIComponent(String(val || '').replace(/\+/g, ' '));
        }
    });
    return result;
}
function parseCurrentCountry() {
    const raw = cookie.get(CookieNames.USER_COUNTRY);
    if (!raw) {
        return null;
    }
    const parts = raw.split('|');
    return parts.length === 2 ? parts[0].toUpperCase() : null;
}
function setPrecision(value) {
    const numVal = parseFloat(value);
    if (isNaN(numVal)) {
        return null;
    }
    return numVal.toFixed(2);
}
function init(opts) {
    _searchUrl = opts && opts.searchUrl || null;
    _reverseUrl = opts && opts.reverseUrl || null;
}
function validateLocation(location, cb) {
    if (typeof location === 'object' && location.coords) {
        if (!_reverseUrl) {
            return cb(Errors.GEOCODER, null);
        }
        const lat = setPrecision(location.coords.latitude);
        const long = setPrecision(location.coords.longitude);
        xhr.ajax({
            method: 'GET',
            url: _reverseUrl,
            data: { lat, long },
        })
            .done((res) => {
            if (!res || res.error || !res.data) {
                return cb(Errors.GEOCODER, null);
            }
            cb(null, res.data);
        })
            .fail(() => cb(Errors.GEOCODER, null));
        return;
    }
    if (!_searchUrl) {
        return cb(Errors.GEOCODER, null);
    }
    const currentLocation = getUserLocation();
    const data = { q: location };
    if (currentLocation.lat) {
        data.lat = currentLocation.lat;
    }
    if (currentLocation.long) {
        data.long = currentLocation.long;
    }
    if (currentLocation.language) {
        data.lang = currentLocation.language;
    }
    xhr.ajax({
        method: 'GET',
        url: _searchUrl,
        data,
    })
        .done((res) => {
        if (!res || res.error || !res.data) {
            return cb(Errors.GEOCODER, null);
        }
        cb(null, res.data);
    })
        .fail(() => cb(Errors.GEOCODER, null));
}
function setUserLocationCookie(location, cb, options) {
    cb = cb || function () { };
    options = options || {};
    validateLocation(location, (error, result) => {
        if (error) {
            return cb(error, null);
        }
        const postal = result.postalCode || null;
        const city = result.city || null;
        const region = result.state || null;
        const country = (result.country || '').toUpperCase();
        const lat = setPrecision(result.latitude);
        const long = setPrecision(result.longitude);
        if (!city && !region) {
            return cb(Errors.MISSING_LOCATION_DETAILS, result);
        }
        if (options.supportedCountries && !options.skipMismatchCheck) {
            const currentCountry = parseCurrentCountry()
                || (getUserLocation().country || '').toUpperCase()
                || (options.defaultCountry || '').toUpperCase()
                || null;
            if (currentCountry && country !== currentCountry) {
                if (!options.supportedCountries.includes(country)) {
                    return cb(Errors.UNSUPPORTED_COUNTRY, null);
                }
                const mismatchData = { city, country, language: 'en-' + country, lat, long, postal, region };
                document.dispatchEvent(new CustomEvent('fd:regionMismatch', {
                    detail: { country }
                }));
                return cb(null, { mismatch: true, detectedCountry: country, userlocation: mismatchData });
            }
        }
        const locationData = { country, language: 'en-' + country, lat, long, city, region, postal };
        cookie.set(CookieNames.USER_LOCATION, serialize(locationData), CookieOpts);
        cookie.set(CookieNames.AKAMAI_ZIP, false, CookieOpts);
        cb(null, { userlocation: locationData });
    });
}
function html5Geolocate(cb) {
    if (!navigator.geolocation) {
        debugLog.warn(Errors.BROWSER_UNSUPPORTED);
        return;
    }
    function onSuccess(results) {
        setUserLocationCookie(results, cb);
    }
    navigator.geolocation.getCurrentPosition(onSuccess, cb, { timeout: GeolocateOpts.timeout });
}
function getZip(cb) {
    const location = getUserLocation() || null;
    if (location.postal && cookie.get(CookieNames.AKAMAI_ZIP) === 'true') {
        html5Geolocate();
        return cb(null, location.postal);
    }
    else if (location.postal) {
        return cb(null, location.postal);
    }
    cb(null, null);
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    getCookieDomain,
    getUserLocation,
    getZip,
    init,
    parseCurrentCountry,
    setUserLocationCookie,
    validateLocation,
    errors: Errors,
    html5Geolocate,
};
extendLegacy('geolocator', module.exports);
export default module.exports;